import React, { useEffect, useRef } from 'react'
// import exampleImg from '../images/example-website-portfolio.png';
import { FaGithub, FaLinkedin  } from "react-icons/fa";
import { CgWebsite } from "react-icons/cg";
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';


const ProjectDisplayWindow = ({selectedProject,totalProjectsCount,setCurrentSelectedProjectId}) => {
const { t } = useTranslation();

  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load(); // Yeni kaynağı yükle
    }
  }, [selectedProject.video]); // selectedProject.video değiştiğinde çalışır



  return (
    <div className='h-fit w-fit flex flex-col gap-4'>
    <div className='w-[450px] max-w-[750px]  max-[1050px]:w-full  rounded-lg items-stretch  max-[1050px]:min-h-0 min-h-[550px]  bg-[#1D1D1D] p-2 gap-2 flex flex-col'>
    {/* <img src={selectedProject.video} className='w-full max-h-[250px] object-cover object-center p-2 rounded-xl' alt="" /> */}
    
    {selectedProject.video ? (
  <video ref={videoRef} className="w-full max-h-[250px] bg-app-socailmedias-bg outline-none max-[1050px]:max-h-[400px] max-[500px]:max-h-[250px]  object-contain object-center rounded-xl" loop autoPlay muted controls>
    <source src={selectedProject.video} type="video/mp4" />
    Tarayıcınız video etiketini desteklemiyor.
  </video>
) : (
  <p>Video yükleniyor...</p>
)}

    <div style={{
  "--width": `110px`, 
  "--height": "30px",
  "--quantity":`${selectedProject.developedWith?.length}`,
}} className='slider h-8 mb-2'>
    <div className='list'>
  {
    selectedProject.developedWith?.length>0 ? (

    selectedProject.developedWith.map((eachItem,i)=>{
      return (<div key={"slider-items-"+i} style={{"--position":`${i+1}`}} id={`mydiv`+i+1} className='item  border flex gap-2  text-app-white border-[#C4C4C4] justify-center items-center text-sm rounded-md'>
        <img src={eachItem.img} className='w-[16px] h-[16px] object-cover' alt="" />
         <span>{eachItem.value}</span>
       </div>)
    })
  ) :null
  }
     
    </div>
    </div>
    <div className='w-full h-full flex-1 justify-between px-3 flex flex-col gap-4'>
      <div className='flex flex-col gap-2'>
        <span className='font-medium text-xl text-app-white'>{selectedProject.title}</span>
      <span className='text-[#c8c8c8]'>{t(selectedProject.description)}</span>
      </div>
      <div className='flex flex-wrap text-app-white gap-2 mb-2 justify-center font-medium items-center w-full'>
      
      <a target='blank' className=' flex-1' href={selectedProject.github}>
      <div className='py-2 px-4 max-[600px]:py-1 max-[600px]:px-2 cursor-pointer  rounded-md bg-app-black group hover:bg-app-hover  flex justify-center items-center gap-2'>
        <FaGithub className='group-hover:text-app-black' size={20}/>
        <span className='group-hover:text-app-black'>Github</span>
      </div>
      </a>
      <a target='blank' className=' flex-1' href={selectedProject.linkedin}>
      <div className='py-2 px-4 max-[600px]:py-1 max-[600px]:px-2  rounded-md group hover:bg-app-hover bg-[#0A66C2] cursor-pointer flex justify-center items-center gap-2'>
        <FaLinkedin className='group-hover:text-[#0A66C2]' size={20}/>
        <span className='group-hover:text-[#0A66C2]'>LinkedIn</span>
      </div>
      </a>
      <a target='blank' className=' flex-1' href={selectedProject.website}>
      <div className='py-2 px-4 max-[600px]:py-1 max-[600px]:px-2  rounded-md  border border-[#AB9D7B] bg-[#AB9D7B]/10 hover:bg-[#AB9D7B]/20 cursor-pointer flex justify-center items-center gap-2'>
        <CgWebsite size={20}/>
        <span>Website</span>
      </div>
      </a>
      </div>
      
   
    </div>

    </div>
    <div className='w-full flex gap-2 px-1 justify-evenly'>
    {[...Array(totalProjectsCount)].map((_, index) => (
  index+1 == selectedProject.id ? (
    <div
      key={"navigation-" + index+1}
      className="h-[3px] flex-1 rounded-md bg-app-dark cursor-pointer"
    ></div>
  ) : (
    <div
      key={"navigation-" + index+1}
      onClick={()=>{setCurrentSelectedProjectId(index+1)}}
      className="h-[3px] flex-1 rounded-md bg-app-socailmedias-bg cursor-pointer"
    ></div>
  )
))}
    </div>
    </div>
  )
}

ProjectDisplayWindow.propTypes = {
    selectedProject: PropTypes.shape({
    id: PropTypes.number.isRequired, // 'id' zorunlu bir sayı olmalı
    title: PropTypes.string,
    description: PropTypes.string,
    img: PropTypes.string,
    developedWith:PropTypes.array,
    video:PropTypes.string,
    github:PropTypes.string,
    linkedin:PropTypes.string,
    website:PropTypes.string,
  }).isRequired,
  setCurrentSelectedProjectId: PropTypes.func.isRequired,
  totalProjectsCount: PropTypes.number,
};

export default ProjectDisplayWindow